import { NavLink } from "react-router-dom";
import { useState, useRef, useEffect } from "react";

import { BsLayoutSidebar, BsLayoutSidebarReverse } from "react-icons/bs";
import { LuUsers } from "react-icons/lu";
import { PiUserSwitch } from "react-icons/pi";
import { MdOutlineDashboard } from "react-icons/md";
import { TbRobot } from "react-icons/tb";
import { CONST } from "../../../../../_config";
import { TbEdit, TbReportAnalytics } from "react-icons/tb";

export default function SidebarUser({ empList, isTeamChat, isNewChat, collapsed, setCollapsed, getChatBookmarkData, selectChatBookMark, chatMarkIdInit, pageName, switchToAdmin }) {

  function getActive(path) {
    const currentPath = window.location.hash.replace(/^#/, "");
    return currentPath === path;
  }
  let [empCollapse, setEmpCollapse] = useState(false);

  const isMobile = window.innerWidth <= 700;

  const menu = [
    {
      name: "Overview",
      path: "/assessment/coachteams",
      isActive: getActive("/assessment/coachteams"),
      icon: <MdOutlineDashboard className="w-5 h-5" />,
    },
    // {
    //   name: "Team Report",
    //   path: "/assessment/myteamreport",
    //   isActive: getActive("/assessment/myteamreport"),
    //   icon: <TbReportAnalytics className="w-5 h-5" />,
    // },
    // {
    //   name: "Avira For Self",
    //   path: "/assessment/mychatbot",
    //   isActive: getActive("/assessment/mychatbot"),
    //   icon: <span class="material-symbols-outlined text-[1.5rem] text-white">
    //     auto_awesome
    //   </span>
    // }
  ];

  const menuTeams = [
    {
      name: "Avira For Coach",
      path: "/assessment/coachteams",
      isActive: getActive("/assessment/coachteams"),
      icon: <span class="material-symbols-outlined text-[1.5rem]">
        auto_awesome
      </span>
    },

  ];


  let chathistoryList =
    getChatBookmarkData && getChatBookmarkData.length > 0
      ? getChatBookmarkData
      : [];

  const chatMenu = [
    { name: "New Chat", chatMarkId: "new" },
    ...chathistoryList.map((ele) => ({ name: ele.question, chatMarkId: ele.id }))
  ];


  return (
    <>
      {/* SIDEBAR */}
      <aside
        className={`fixed top-0 left-0 z-50 h-screen bg-[#f9fafb] border-r transition-all duration-300 ease-in-out flex flex-col ${collapsed ? "md:w-20" : "md:w-64"} md:translate-x-0 w-64 ${collapsed ? "-translate-x-full" : "translate-x-0"}
        `}
      >
        {/* HEADER */}
        <div className="px-4 py-5 flex items-center justify-between">
          {!collapsed && (
            <img src={CONST.IMAGES_URL + "TalentPlusStrengths_logo.svg"} alt="logo" className="w-32" />
          )}
          <button onClick={() => setCollapsed(!collapsed)} className="hidden md:flex p-2 rounded-lg hover:bg-gray-200">
            <BsLayoutSidebar className="w-5 h-5" />
          </button>
        </div>

        {/* MENU */}
        <nav className="px-2 space-y-1">
          {menu.map((item) => (
            <NavLink
              key={item.name}
              to={item.path}
              onClick={() => setCollapsed(item.name === "AI Assistant" ? false : true)}
              className={({ }) =>
                `group flex items-center gap-3 px-4 py-3 rounded-lg text-base font-medium transition 
              ${item.isActive
                  ? "bg-gradient-to-r from-[#673AB7] to-[#1976D2] text-white"
                  : "hover:bg-gray-200 hover:text-black"
                }`
              }
            >
              {item.icon}
              {!collapsed && item.name}
            </NavLink>
          ))}

          {pageName === "/assessment/mychatbot" && !collapsed ?
            chatMenu.map((item, index) => (
              (item && item.name) &&
              <div
                key={index}
                onClick={() => { setCollapsed(isMobile ? !collapsed : collapsed); selectChatBookMark(item.chatMarkId); }}
                className={`
                group flex items-center px-3 py-2.5 rounded-md cursor-pointer
                transition-colors duration-200 
                    ${isNewChat ? true : (item.chatMarkId === chatMarkIdInit)
                    ? "bg-gray-200 text-gray-900"
                    : "text-gray-700 hover:bg-gray-200"
                  }
            `}
              >
                {!collapsed && (
                  <div className="ml-2 flex  space-x-3 w-52">
                    {item.name === "New Chat" && <TbEdit size={18} />}
                    <span className=" text-sm leading-snug truncate group-hover:text-gray-900 overflow-hidden" title={item.name}>{item.name}</span>
                  </div>
                )}
              </div>
            )) : null}
        </nav>

        {isTeamChat && <>
          <div className="mt-4" />

          <nav className="px-2 space-y-1">
            {menuTeams.map((item) => (
              <>
                <NavLink
                  key={item.name}
                  to={item.path}
                  onClick={() => setEmpCollapse(!empCollapse)}
                  className={'group flex items-center gap-3 px-4 py-3 rounded-lg text-base font-medium transition hover:bg-gradient-to-r from-[#673AB7] to-[#1976D2] hover:text-white' +
                    (!empCollapse && false
                      ? "bg-gradient-to-r from-[#673AB7] to-[#1976D2] text-white"
                      : " hover:bg-gray-200 hover:text-black")}
                >
                  {item.icon}
                  {!collapsed && item.name}
                </NavLink>

              </>
            ))}
          </nav>

        </>}




      </aside>



      {/* MOBILE OVERLAY */}
      {!collapsed && (
        <div
          className="fixed inset-0 bg-black/40 z-40 md:hidden"
          onClick={() => setCollapsed(true)}
        />
      )}
    </>
  );
}